import { HighlightButton } from './components/HighlightButton';
import { HighlightDropdown } from './components/HighlightDropdown';

export const HighlightComponent = { Button: HighlightButton, Dropdown: HighlightDropdown };
